var map = {
	".": 331,
	"./": 331,
	"./Component": 1060,
	"./Component.js": 1060,
	"./OldUi": 1061,
	"./OldUi.js": 1061,
	"./RenderComponent": 764,
	"./RenderComponent.js": 764,
	"./TopActions": 763,
	"./TopActions.js": 763,
	"./index": 331,
	"./index.js": 331,
	"./style": 427,
	"./style.js": 427
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4212;
module.exports = webpackAsyncContext;